import React from 'react'

const Footer = ({appName}) => {
  return (
    <>
      <footer id='footer' className='footer'>
        <div className='copyright d-flex-column'>
          <div>&copy; 2023 ChipGlobe GmbH</div>
          <div>ChipGlobe™ and Carenuity™ are Trademarks of ChipGlobe GmbH</div>
        </div>
      </footer>
      {/* <!-- End Footer --> */}

      <a
        href='#'
        className='back-to-top d-flex align-items-center justify-content-center'
      >
        <i className='bi bi-arrow-up-short'></i>
      </a>
    </>
  );
}

export default Footer